import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterInvoiceProgram'
})
export class FilterInvoiceProgramPipe implements PipeTransform {

  transform(values: Array<any>, args?: any): any {
    return values.filter(m=>m.display_program===args);
  }

}
